import AddToCartButton from '~/components/cart/AddToCartButton.vue'

const cartComponents = [
  AddToCartButton,
]

export default cartComponents
